import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import InnerBanner from "../../components/common/InnerBanner";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getPostalSectors } from "../../redux/reducers/postalSectorsSlice";
import { setAddressCheckedFromStore, setSelectAddress } from "../../redux/reducers/createOrderSlice";
import { getProfileView } from "../../redux/reducers/authSlice";
import ProfessionalBanner from "../../components/common/ProfessionalBanner";
import AddEditAddressModal from "../../components/common/Profile/AddEditAddress";

const cleanString = (str) => (str || '').replace(/\s+/g, '').toLowerCase();

const isAddressMatching = (addr1, addr2) => {
    if (!addr1 || !addr2) return false;
    if (addr1._id && addr2._id && addr1._id === addr2._id) return true;
    return (
        cleanString(addr1.postalCode) === cleanString(addr2.postalCode) &&
        cleanString(addr1.address) === cleanString(addr2.address) &&
        cleanString(addr1.unitNo) === cleanString(addr2.unitNo)
    );
};

const CheckoutPagePostalAddress = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const dispatch = useDispatch()
    const { user, myprofile
    } = useSelector((state) => state.auth);
    const { selectedAddress, addressCheckedFromStore } = useSelector((state) => state.createOrderSlice)
    const { postalData } = useSelector((state) => state.poastalSectorsLists)
    const [addressChecked, setAddressChecked] = useState(false)
    const [chooseService, setChooseService] = useState(selectedAddress ? true : false)
    const [selectedData, setSelectedData] = useState(selectedAddress)
    const [locations, setLocations] = useState(selectedAddress ?? {
        address: '',
        country: '',
        postalCode: '',
        isPrimary: true,
        isActive: true,
        location: {
            type: "Point",
            coordinates: [""]
        }
    })
    const [showAddressModal, setShowAddressModal] = useState(false)
    const [postalCode, setPostalCode] = useState((!user && selectedAddress?.postalCode) ? selectedAddress?.postalCode : "")
    const gotoAnnotaion = () => {
        if (locations?.postalCode !== "" && location?.state?.serviceType === "order-booking") {
            // if (location?.state?.serviceType === "order-booking") {
            //   navigate("/order-booking");

            // }

            navigate("/order-booking");
        }
        else if (locations?.postalCode !== "" && location?.state?.serviceType === "professional") {
            navigate("/professional");

        }


    };

    const handleAddress = (addressObj) => {
        if (addressObj?.postal_code) {
            setLocations({
                ...locations,
                address: addressObj?.postal_code,
                country: addressObj?.country,
                postalCode: addressObj?.postal_code,
                isPrimary: true,
                isActive: true,
                isFromInput: true,
                location: {
                    type: "Point",
                    coordinates: [Number(addressObj?.lng), Number(addressObj?.lat)]
                }
            })

            dispatch(setSelectAddress(
                {
                    selectedAddress: {
                        ...locations,
                        address: '',
                        country: addressObj?.country,
                        postalCode: addressObj?.postal_code,
                        isPrimary: true,
                        isActive: true,
                        isFromInput: true,
                        location: {
                            type: "Point",
                            coordinates: [Number(addressObj?.lng), Number(addressObj?.lat)]
                        }
                    }
                }
            ))


        }
        else if (!addressObj?.postal_code) {
            toast.error('Try to search more precisely')

        }
    }
    useEffect(() => {
        !user && dispatch(getPostalSectors())
    }, [])
    useEffect(() => {
        if (user) {
            dispatch(getProfileView())
        }
    }, [])
    const addressSelect = (item) => {
        setChooseService(true)
        setPostalCode("")
        setLocations(item)
        dispatch(setSelectAddress({ selectedAddress: item }))
        dispatch(setAddressCheckedFromStore({ addressCheckedFromStore: true }))
        setAddressChecked(true)
    }
    useEffect(() => {
        if (user && myprofile?.customer?.locations?.length && selectedAddress?.isFromInput) {
            const matchingAddress = myprofile.customer.locations.find((loc) =>
                isAddressMatching(selectedAddress, loc)
            );
            if (matchingAddress) {
                addressSelect(matchingAddress);
            }
        }
    }, [myprofile, selectedAddress, user]);
    useEffect(() => {
        if (postalCode.length > 5) {
            getGeocodeFromPostalCode(postalCode)
        }
    }, [postalCode])
    const getAddressObject = (address_components) => {
        const ShouldBeComponent = {
            street_number: ["street_number"],
            postal_code: ["postal_code"],
            street: ["street_address", "route"],
            province: [
                "administrative_area_level_1",
                "administrative_area_level_2",
                "administrative_area_level_3",
                "administrative_area_level_4",
                "administrative_area_level_5",
            ],
            city: [
                "locality",
                "sublocality",
                "sublocality_level_1",
                "sublocality_level_2",
                "sublocality_level_3",
                "sublocality_level_4",
            ],
            country: ["country"],
        };

        let address = {
            street_number: "",
            postal_code: "",
            street: "",
            province: "",
            city: "",
            country: "",
        };


        address_components.forEach((component) => {
            for (var shouldBe in ShouldBeComponent) {
                if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
                    if (shouldBe === "country") {
                        address[shouldBe] = component.short_name;
                    } else {
                        address[shouldBe] = component.long_name;
                    }
                }
            }
        });

        // Fix the shape to match our schema
        address.address = address.street_number + " " + address.street;
        delete address.street_number;
        delete address.street;
        if (address.country === "US") {
            address.state = address.province;
            delete address.province;
        }
        return address;
    };
    const getGeocodeFromPostalCode = async (postalCode) => {
        const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
        const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${postalCode}&key=${apiKey}`;

        try {
            const response = await fetch(apiUrl);
            const data = await response.json();

            // Extract relevant information from the data
            const location = data.results[0].geometry.location;
            const addressComponents = data.results[0].address_components;
            const addressObject = addressComponents && {
                ...getAddressObject(addressComponents),
                lat: `${Number(location?.lat?.toFixed(6))}`,
                lng: `${Number(location?.lng?.toFixed(6))
                    }`,
            };

            handleAddress(addressObject);
            // You can now use the location and address components as needed in your application
        } catch (error) {
            setLocations({
                address: '',
                country: '',
                postalCode: '',
                isPrimary: true,
                isActive: true,
                location: {
                    type: "Point",
                    coordinates: [""]
                }
            })

            toast.error("Please enter a valid postal code")
        }
    };
    const handleInputChangeForOnlyNumbers = (e) => {
        e.target.value = e.target.value.replace(/\D/g, '');
        setPostalCode(e.target.value);
    };


    const onClickHandlerForPostalCodeInputBox = () => {
        if (addressChecked || addressCheckedFromStore) {
            setAddressChecked(false)
            dispatch(setAddressCheckedFromStore({ addressCheckedFromStore: false }))
            setLocations({
                address: '',
                country: '',
                postalCode: '',
                isPrimary: true,
                isActive: true,
                isFromInput: true,
                location: {
                    type: "Point",
                    coordinates: [""]
                }
            })

            dispatch(setSelectAddress({ selectedAddress: null }))
            setPostalCode("")
        }
    }


    return (
        <>
            <div className="general-cleaning-sec">
                <div className="">
                    {/* {location?.state?.serviceType === "order-booking" ? <InnerBanner /> : <ProfessionalBanner />} */}
                    {!user && <form onSubmit={gotoAnnotaion}>
                        <div className="location-search">
                            <input
                                type="search"
                                className="form-control"
                                placeholder="123456"
                                maxLength="6"
                                value={addressCheckedFromStore ? "" : postalCode}
                                onClick={() => { onClickHandlerForPostalCodeInputBox(); setChooseService(false) }}
                                onChange={(e) => handleInputChangeForOnlyNumbers(e)}
                            />
                            <div className="next-arrow" style={{
                                cursor: locations?.postalCode === ""
                                    ? "not-allowed"
                                    : "",
                            }} onClick={gotoAnnotaion}>
                                Next
                                <FontAwesomeIcon icon={icon({ name: "angle-right" })} />
                            </div>
                        </div>
                        {!user && <div className="ex-login text-center">
                            <p className="arrow-img" style={{ cursor: "pointer" }} onClick={() => navigate('/login')}>
                                Existing Customer Login Here{" "}
                                <img src="/assets/images/arrow.png" alt="" />
                            </p>
                        </div>}
                    </form>}
                    {myprofile?.customer?.locations?.length ?
                        <div className="service-location">
                            <div className={`add-location`}>
                                <p >Choose a Service location:</p>
                                <p className={`myprofile-add`}>Need a different address with same pincode? <span onClick={() => setShowAddressModal(true)}>add a new address</span></p>
                            </div>

                            <div className="location-item-wrap">
                                {myprofile?.customer?.locations?.filter(loc => selectedAddress?.postalCode === loc?.postalCode)?.map(item => {
                                    return (
                                        <>
                                            <div className="location-item-p">
                                                <div className="location-item">
                                                    <label >
                                                        <input onClick={() => addressSelect(item)} id="default-radio-1" type="radio" checked={selectedAddress?._id === item?._id || isAddressMatching(selectedAddress, item)} value="" name="default-radio" />
                                                        <div >
                                                            <p className={`item-title`}>{item?.title}:</p>
                                                            <p >
                                                                {item?.address}
                                                            </p>
                                                            <p >
                                                                {item?.unitNo}
                                                            </p>
                                                            <p >
                                                                Singapore {item?.postalCode}
                                                            </p>
                                                            <p className={`item-generallocation`}>
                                                                {item?.generalLocation}
                                                            </p>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>



                                        </>

                                    )
                                })}
                            </div>
                            {chooseService && addressCheckedFromStore && <div className="postal-btn-b">
                                <button type="button" onClick={gotoAnnotaion} className="btn">Next</button>
                            </div>}
                        </div>
                        :
                        (user && !myprofile?.customer?.locations?.length) ? <div className={`add-location address-goto-profile`}>
                            <p className={`myprofile-add`}><span onClick={() => setShowAddressModal(true)}>Add address</span> to book new order</p>
                        </div> : null
                    }
                </div>
            </div>
            {showAddressModal && <AddEditAddressModal setSelectedData={setSelectedData} isOpen={showAddressModal} myprofile={selectedAddress} setIsOpen={setShowAddressModal} title={"Address(es)"} postalData={postalData} checkOut={true} />}
        </>
    );
};

export default CheckoutPagePostalAddress;
